module.exports = __webpack_public_path__ + "static/img/mute_camera2.2cf7b90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/mute_camera2.png
// module id = Lb//
// module chunks = 24